import React, { ReactNode, useContext, useEffect, useState } from 'react';

import {
  BuildingSummaryFilters,
  BuildingSummaryInput,
  BuildingTypeColor,
} from '@totem/components/portfolio/buildings/list/buildingSummary/types';
import {
  addReportFilters,
  buildReportFilters,
} from '@totem/components/portfolio/buildings/list/buildingSummary/utilities';
import SquareFootageContext from '@totem/components/portfolio/buildings/list/squareFootage/SquareFootageContext';
import { Items } from '@totem/components/portfolio/buildings/list/squareFootage/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { Params } from '@totem/types/common';
import { defaultChartColors } from '@totem/utilities/charts';
import { isNotNull } from '@totem/utilities/common';
import { BUILDINGS_ENDPOINT } from '@totem/utilities/endpoints';
type Props = {
  staticFilters?: BuildingSummaryFilters;
  input: BuildingSummaryInput;
  children?: ReactNode;
};
const SquareFootageContainer = ({ children, input, staticFilters }: Props) => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const [data, setData] = useState<Items>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [typeColors, setTypeColors] = useState<BuildingTypeColor[]>([]);
  useEffect(() => {
    if (isNotNull(data) && typeColors.length === 0) {
      const newTypeColors = [];
      for (let idx = 0; idx < data.length; idx++) {
        newTypeColors.push({
          type: data[idx].type,
          color: defaultChartColors[idx % defaultChartColors.length],
        });
      }
      setTypeColors(newTypeColors);
    }
  }, [data]);
  const buildParameters = () => {
    const params: Params = {
      paging: {
        page: input.page,
        pageSize: input.pageSize,
      },
      sort: {
        field: input.sortField,
        direction: +input.sortDirection,
      },
      filters: buildReportFilters(input),
    };
    params.filters = addReportFilters(params.filters, staticFilters);
    return params;
  };
  useEffect(() => {
    setIsLoading(true);
    const params: Params = buildParameters();
    fetch(`${BUILDINGS_ENDPOINT}/squareFootage`, {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
      body: JSON.stringify(params),
    })
      .then((res) => res.json())
      .then((result: Items) => {
        setData(result);
      })
      .then(() => {
        setIsLoading(false);
      });
  }, [
    input.regionId,
    input.buildingId,
    input.name,
    input.searchName,
    input.type,
    userProfile.organization.id,
    getApiToken,
  ]);
  return (
    <SquareFootageContext.Provider
      value={{
        data,
        loading: isLoading,
        colors: typeColors,
      }}
    >
      {children}
    </SquareFootageContext.Provider>
  );
};
export default SquareFootageContainer;
